if (!customElements.get('knotz-bedding-home')) customElements.define('knotz-bedding-home', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const grid = this.querySelector('[data-bedding-grid]');
    const cards = [...this.querySelectorAll('[data-bedding-card]')];
    const sort = this.querySelector('[data-bedding-sort]');
    const apply = () => {
      cards.sort((a,b) => {
        const availability = Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true');
        if (availability) return availability;
        const price = Number(a.dataset.price) - Number(b.dataset.price);
        return sort.value === 'price-low' ? price : sort.value === 'price-high' ? -price : Number(a.dataset.featured) - Number(b.dataset.featured);
      });
      cards.forEach((card,index) => { grid.append(card); card.hidden = index >= Number(this.dataset.limit || 4); });
    };
    sort.addEventListener('change', apply);
    apply();
  }
});
